import { isMobile } from "react-device-detect";

const Style = {
  formInput: (width, color, height = "40px", fontSize = "16px") => {
    if (color === "green") {
      return {
        width: width,
        border: `2px solid ${color}`,
        height: height,
        fontSize: fontSize,
        paddingLeft: "5%",
        backgroundColor: "#e8fbe8",
        borderRadius: "10px",
        marginLeft: "5%",
      };
    } else {
      return {
        width: width,
        border: `2px solid ${color}`,
        height: height,
        fontSize: fontSize,
        marginLeft: "5%",
        borderRadius: "10px",
        paddingLeft: "5%",
      };
    }
  },
  form: {
    display: "grid",
    gridGap: "15px",
    justifyContent: "center",
    paddingTop: isMobile ? "5%" : "100px",
    marginLeft: isMobile ? "" :"150px"
  },
  uploadButton: (width) => {
    return {
      width: width,
      height: "40px",
      fontSize: "16px",
      marginLeft: "5%",
    };
  },
  disclaimer: {
    color: "red",
    textAlign: "center",
    paddingLeft: isMobile? "":"150px"
  },
  recaptchaOuter: (width) => {
    return {
      display: "grid",
      gridTemplateColumns: isMobile ? "45% 50%": "40% 60%",
      gridGap: "10px",
      width: width,
      height: "50px",
      borderRadius: "5px",
      marginLeft: "5%",
    };
  },
captchaBox: () =>{
  return{
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    fontSize: "1.2em"
  };
},

  infoAndFormDevider: () => {
    if (isMobile) {
      return {
        display: "grid",
        justifyContent: "center",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "50% 50%",
        justifyContent: "center",
      };
    }
  },
  infoPart: () => {
    if (isMobile) {
      return {
        marginLeft: "5%",
        width: "90%",
      };
    } else {
      return {
        paddingRight: "50px",
        marginLeft: "auto",
      };
    }
  },
};

export default Style;
